import { createReducer } from 'redux-starter-kit';
import moment from 'moment';

import Notice from '../../modules/utils/Notice';
import { handleError } from '../../modules/utils/handleError';
import { RequestsApi } from './RequestsApi';
import { P_STATUS } from '../../_helpers/Constants';
import * as Dict from '../../modules/utils/Dict';

export const requestsModule = 'requests';
const LOADING_TABLE = `${requestsModule}/LOADING_TABLE`;
const SET_DATA = `${requestsModule}/SET_DATA`;

const initialState = {
  loadingTable: false,
  tableData: {
    content: [],
    totalElements: 0
  }
};

export default createReducer(initialState, {
  [LOADING_TABLE]: (state, action) => {
    state.loadingTable = action.loading;
  },
  [SET_DATA]: (state, { tableData }) => {
    state.tableData = {
      ...tableData,
      totalElements: tableData.pageNumber === 1
        ? tableData.totalElements
        : state.tableData.totalElements
    };
  }
});

export const getRequests = filters => async (dispatch, getState) => {
  try {
    dispatch({ type: LOADING_TABLE, loading: true });

    filters = {
      ...filters,
      requesterIinBin: getState().login.user.bin ?? getState().login.user.iin,
      processingStatuses: [
        P_STATUS.IN_PROGRESS,
        P_STATUS.READY_FOR_SIGN,
        P_STATUS.SUBMITTED,
        P_STATUS.APPROVED,
      ]
    };

    const { data } = await RequestsApi.getRequests(filters);

    if (data.status === 'SUCCESS') {

      const content = [];
      for (let request of data.result.content) {
        let serviceType = request.serviceType.toLowerCase();
        if (!serviceType.includes('_short')) {
          serviceType = `${serviceType}_short`;
        }
        const status = await Dict.item('gu_status_res', request.processingStatus);
        content.push({
          ...request,
          serviceType,
          status,
          submissionDate: request.submissionDate && moment(request.submissionDate).format('L')
        });
      }

      dispatch({ type: SET_DATA, tableData: { ...data.result, content } });
    }

  } catch (error) {
    Notice.error(handleError(error));
  } finally {
    dispatch({ type: LOADING_TABLE, loading: false });
  }
};